export default function isArray(value) {
    return Array.isArray(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/is-array.js
// module id = 506
// module chunks = 29